<template>
  <div class="container">
    <template v-if="poetryDetail">
      <div class="poetry item">
        <div class="name">
          {{poetryDetail.poetry.name}}
        </div>
        <div class="poet-name">
          {{poetryDetail.poetry.poetName}}·{{poetryDetail.poetry.dynasty}}
        </div>
        <div class="poetry-content">
          {{poetryDetail.poetry.content}}
        </div>
      </div>
      <div class="intro item" v-if="poetryDetail.detail.intro">
        <div class="title">评析</div>
        <span class="content">{{poetryDetail.detail.intro}}</span>
      </div>
      <div class="translation item" v-if="poetryDetail.detail.translation">
        <div class="title">翻译</div>
        <span class="content">{{poetryDetail.detail.translation}}</span>
      </div>
      <div class="annotation item" v-if="poetryDetail.detail.annotation">
        <div class="title">注释</div>
        <span class="content">{{poetryDetail.detail.annotation}}</span>
      </div>
      <div class="appreciation item" v-if="poetryDetail.detail.appreciation">
        <div class="title">赏析</div>
        <span class="content">{{poetryDetail.detail.appreciation}}</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      poetryDetail: null
    }
  },
  methods: {
    get() {
      this.$get('/poetryapi/poetry/get', {id: this.$route.params.id}).then(res => {
        this.poetryDetail = res;
        document.title = res.poetry.name + '-诗词馆';
      });
    }
  },
  mounted() {
    document.title = '诗词馆';
    this.get();
  }
}
</script>

<style scoped lang="less">
.container {
  padding: 12px;

  .poetry {
    display: flex;
    flex-direction: column;
    align-items: center;

    .name {
      font-size: 16px;
      line-height: 26px;
    }
    .poet-name {
      font-size: 14px;
      line-height: 24px;
      margin-top: 6px;
    }
    .poetry-content {
      font-size: 14px;
      line-height: 28px;
      color: #666666;
      font-weight: 600;
      white-space: pre-line;
      letter-spacing: 3px;
    }
  }
  .item {
    border-radius: 6px;
    margin-bottom: 12px;
    background: #FFFFFF;
    padding: 12px;
    box-shadow: 0 1px 3px 1px rgba(0,0,0,.14);
    -webkit-box-shadow: 0 1px 3px 1px rgba(0,0,0,.14);

    .title {
      font-size: 18px;
      margin-bottom: 6px;
    }
    .content {
      font-size: 14px;
      line-height: 24px;
    }
  }
}
</style>
